enum EmployeeQueueTaskAccessEnum {
	VisibilityOtherTask = 0,
	CreateTask = 1,
	UpdateOtherTask = 2,
	FinallyEstimate = 3,
	QueueTaskAccess = 4
}
export default EmployeeQueueTaskAccessEnum
